"use client";

import React from "react";
import SafeHtml from "@/components/ui/SafeHtml";
import { Button } from "@/components/ui/Button";
import { ArrowIcon } from "@/components/ui/Icons";
import { toAbsoluteUrl } from "@/lib/toAbsoluteUrl";
import Wrapper from "@/components/ui/Wrapper";
import type { ContentSimpleFields } from "@/types/acf";

export default function ContentSimple({ data }: { data: ContentSimpleFields }) {
  if (!data || data.hide) return null;

  const sectionTitle = data.title ?? "";
  const rows = Array.isArray(data.content_simple) ? data.content_simple : [];

  if (!sectionTitle && rows.length === 0) return null;

  return (
    <div id={data.id} className="w-full">
      <Wrapper>
          {/* section title (group-level) */}
          {sectionTitle ? (
            <h2 className="text-title-2">
              <SafeHtml content={sectionTitle} />
            </h2>
          ) : null}

          {/* items */}
          <div className={sectionTitle ? "mt-4 flex flex-col gap-4" : "flex flex-col gap-4"}>
            {rows.map((row, i) => {
              const title = row?.title ?? "";
              const text = row?.text ?? "";

              const rawHref =
                row?.button && typeof row.button === "object" ? (row.button.url ?? "") : "";
              const isAnchorLink = rawHref.trim().startsWith("#");

              if (!title && !text && !row?.button) return null;

              return (
                <div key={i} className="w-full bg-fuji-grey">
                  <div className="px-6 py-8">
                    {title ? (
                      <h3 className="text-title-3">
                        <SafeHtml content={title} />
                      </h3>
                    ) : null}

                    {text ? (
                      <div className="mt-4 min-w-0 break-words">
                        <SafeHtml content={text} flow />
                      </div>
                    ) : null}

                    {row?.button && typeof row.button === "object" && row.button.url ? (
                      <div className="mt-6">
                        <Button
                          as="link"
                          href={toAbsoluteUrl(row.button.url) ?? "#"}
                          target={row.button.target || "_self"}
                          rel={row.button.target === "_blank" ? "noopener noreferrer" : undefined}
                          icon={isAnchorLink ? <ArrowIcon direction="down" /> : undefined}
                        >
                          {row.button.title || "Learn more"}
                        </Button>
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
      </Wrapper>
    </div>
  );
}
